import App from './App';
import React from 'react';
import ReactDOM from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import { QueryClientProvider, QueryClient } from 'react-query'

const queryClient = new QueryClient();

document.querySelectorAll(".member-subscription").forEach((domElement) => {
  const root = ReactDOM.createRoot(domElement);
  root.render(
    <React.StrictMode>
      <QueryClientProvider client={queryClient}>
        <App instanceElement={domElement} />
      </QueryClientProvider>
    </React.StrictMode>
  );
})

reportWebVitals();
